/* eslint-disable react/no-danger */
import React from 'react';

import { BannerData } from './models';

import './HomePageBanner.scss';

interface HomePageBannerProps {
  data?: BannerData;
}

const ArrowIcon = () => (
  <svg className="discover-button__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
    <path d="M329.18 938.667l438.82-426.667-438.82-426.667-73.18 71.103 365.743 355.564-365.743 355.563 73.18 71.104z" />
  </svg>
);

const HomePageBanner = ({ data }: HomePageBannerProps) => {
  const {
    backgroundImage,
    backgroundImageMobile,
    overlayImage,
    headingTitle,
    headingSubTitle,
    descriptionShort,
    buttonTitle,
    buttonLink,
    disclaimer,
  } = data || {};

  return (
    <section
      className="homepage-banner"
      style={
        {
          '--bg-image-desktop': `url(${backgroundImage?.url ?? ''})`,
          '--bg-image-mobile': `url(${backgroundImageMobile?.url || backgroundImage?.url || ''})`,
        } as React.CSSProperties
      }
    >
      <div className="homepage-banner__content">
        <div className="homepage-banner__text">
          <div>
            {headingTitle && <h1 className="homepage-banner__title">{headingTitle}</h1>}
            {headingSubTitle && <p className="homepage-banner__subtitle">{headingSubTitle}</p>}
            {descriptionShort && <p className="homepage-banner__description">{descriptionShort}</p>}
          </div>

          <div>
            {buttonTitle && buttonLink && (
              <a className="homepage-banner__discover-button discover-button" href={buttonLink}>
                {buttonTitle}
                <ArrowIcon />
              </a>
            )}

            {disclaimer && (
              <div
                className="homepage-banner__disclaimer"
                dangerouslySetInnerHTML={{ __html: disclaimer }}
              />
            )}
          </div>
        </div>

        {overlayImage && (
          <img
            className="homepage-banner__overlay-image"
            src={overlayImage?.url}
            alt={headingTitle || 'homepage banner'}
            loading="eager"
            fetchPriority="high"
          />
        )}
      </div>
    </section>
  );
};

HomePageBanner.displayName = 'HomePageBanner';
export default HomePageBanner;
